import React from 'react';
const RnpIcon = () => (
  <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.75 0C15.8438 0 16.75 0.90625 16.75 2V12C16.75 13.125 15.8438 14 14.75 14H2.75C1.625 14 0.75 13.125 0.75 12V2C0.75 0.90625 1.625 0 2.75 0H14.75ZM2.75 12.5H8V4H2.25V12C2.25 12.2812 2.46875 12.5 2.75 12.5ZM9.5 12.5H14.75C15 12.5 15.25 12.2812 15.25 12V4H9.5V12.5Z"
      fill="#10182B"
    />
  </svg>
);

export default RnpIcon;
